if (!customElements.get('card-swatches')) {
    customElements.define(
        'card-swatches',
        class CardSwatches extends HTMLElement {
            constructor() {
                super();
            }
    
            async connectedCallback() {
                this.card = this.closest('.product-card-wrapper')
                this.productData;
                FH.observer.observe(this);
                window.addEventListener(`intersection--${this.dataset.observer}`, async () => {
                    await this.fetchProductData()
                    this.bindSwatches()
                });
            }
    
            async fetchProductData() {
                const firstSwatch = this.querySelector('.product-option-label--swatch')
                if (!firstSwatch) return
    
                const firstUrl = firstSwatch.getAttribute('href')
                if (!firstUrl) return
    
                const productUrl = firstUrl.split('?')[0]
                const productJson = await fetch(`${productUrl}.json`).then(res => res.json())
                this.productData = productJson
            }
    
            bindSwatches() {
                const swatches = Array.from(this.querySelectorAll('.product-option-label--swatch'))
                if (!swatches) return
                swatches.forEach((swatch) => {
                    ['mouseenter', 'click'].forEach((event) => {
                        swatch.addEventListener(event, (ev) => {
                            if (ev.type === 'click' && window.matchMedia('(max-width: 749px)').matches) {
                                ev.preventDefault()
                            }
                            swatches.find((swatch) => swatch.classList.contains('swatch--active'))?.classList.remove('swatch--active')
                            swatch.classList.add('swatch--active')
                            const swatchValue = swatch.dataset.value
                            const variantData = this.productData.product.variants.find((variant) => variant.option1 === swatchValue || variant.option2 === swatchValue || variant.option3 === swatchValue)
                            if (!variantData) return
                            const price = variantData.price
                            const imageSrc = this.productData.product.images.find((image) => image.id === variantData.image_id)?.src
                            const url = swatch.getAttribute('href')
                            if (imageSrc) {
                                Array.from(this.card.querySelectorAll('.media--hover, .media img')).forEach((imageEl) => {
                                    imageEl.src = imageSrc
                                    imageEl.removeAttribute('srcset')
                                })
                            }
                            if (price) {
                                const priceEl = this.card.querySelector('.price__container')
                                if(window.siteCurrency) {
                                    if (priceEl) priceEl.innerHTML = `${window.siteCurrency.symbol}${Currency.convert(price, 'USD', window.siteCurrency.code).toFixed(2)}`
                                } else {
                                    if (priceEl) priceEl.innerHTML = `$ ${price}`
                                }
                            }
                            if (url) {
                                Array.from(this.card.querySelectorAll('.card__heading a, .card-information a.button')).forEach((cardLink) => {
                                    cardLink.setAttribute('href', url)
                                })
                                const quickShopBtn = this.card.querySelector('.quick-add__submit')
                                if (quickShopBtn) quickShopBtn.setAttribute('data-product-url', url)
                            }
                        })
                    })
                })
            }
        }
    )
}